import React from 'react';
import { Card, CardHeader, } from 'reactstrap';
import { FaCircle } from 'react-icons/fa';
import { P } from "../../../../AbstractElements";
import ActiveParikamiTableCardBody from './ActiveParikamiTableCardBody';

const ActiveParikamiTable = () => {


    return (
        <Card className="product">
            <CardHeader className="pb-0">
                <div className="d-flex justify-content-between">
                    <div className="flex-grow-1">
                        <P attrPara={{ className: "square-after font-weight-bold" }} >
                            Active Parikramavasi's <FaCircle size="0.5em" />
                        </P>
                    </div>
                </div>
            </CardHeader>
            <ActiveParikamiTableCardBody />
        </Card>
    );
};

export default ActiveParikamiTable;
